export const ACTIVATE_ACCOUNT_REQUEST = "ACTIVATE_ACCOUNT_REQUEST";
export const ACTIVATE_ACCOUNT_REQUEST_SUCCESS =
  "ACTIVATE_ACCOUNT_REQUEST_SUCCESS";
export const ACTIVATE_ACCOUNT_REQUEST_ERROR = "ACTIVATE_ACCOUNT_REQUEST_ERROR";
